<template>
	<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_640_46525)"><path d="M10.5003 2.68984L3.4128 6.56172L10.5003 10.0398L17.5878 6.56172L10.5003 2.68984ZM10.8284 1.37734L19.3597 5.97109C19.819 6.23359 19.819 6.88984 19.3597 7.15234L10.8284 11.418C10.6315 11.4836 10.4347 11.4836 10.2378 11.418L1.70655 7.15234C1.24717 6.88984 1.24717 6.23359 1.70655 5.97109L10.2378 1.37734C10.369 1.31172 10.6315 1.31172 10.8284 1.37734ZM2.23155 9.90859L10.5003 13.9773L18.769 9.90859C19.0972 9.77734 19.4909 9.90859 19.6222 10.2367C19.7534 10.5648 19.6222 10.9586 19.294 11.0898L10.5003 15.4867L1.70655 11.0898C1.37842 10.9586 1.24717 10.5648 1.37842 10.2367C1.5753 9.90859 1.96905 9.77734 2.23155 9.90859ZM2.23155 13.8461L10.5003 17.9148L18.769 13.8461C19.0972 13.7148 19.4909 13.8461 19.6222 14.1742C19.7534 14.5023 19.6222 14.8961 19.294 15.0273L10.5003 19.4242L1.70655 15.0273C1.37842 14.8961 1.24717 14.5023 1.37842 14.1742C1.5753 13.8461 1.96905 13.7148 2.23155 13.8461Z" :fill="color"/></g><defs><clipPath id="clip0_640_46525"><rect width="21" height="21" fill="white"/></clipPath></defs></svg>
</template>
<script>
	export default {
		name : "icon-all",
		props:{
			color: {
				type: String,
				default: "#000000",
			},
		},
	}
</script>


